module.exports = __webpack_public_path__ + "img/cloth_g1_hat_09.2a08ac98.svg";